export const iconFontAwesomeDesignPenNib = (
	<i className="fa-solid fa-pen-nib"></i>
);
